export default "__VITE_ASSET__DjZboULr__"